import React from "react";
import '../../css/components/controls/HrnbTextArea.css'

export default function HrnbTextArea({
                                         label,
                                         className = "",
                                         value,
                                         onChange,
                                         placeholder = "",
                                         error = "",
                                         hint = "",
                                         disabled = false,
                                         rows = 4,
                                         ...props
                                     }) {
    return (
        <div className={`hrnb-textarea-wrap ${className} ${error ? "hrnb-textarea--error" : ""} ${disabled ? "hrnb-textarea--disabled" : ""}`}>
            {label && <label className="hrnb-textarea__label">{label}</label>}
            <textarea
                className="hrnb-textarea"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
                {...props}
            />
            {error
                ? <div className="hrnb-textarea__error">{error}</div>
                : hint && <div className="hrnb-textarea__hint">{hint}</div>
            }
        </div>
    );
}
